import cx from 'classnames';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { useLocation } from 'react-router-dom';
import menuItems from '../../assets/data/menu';
import useTheme from '../../hooks/useTheme';
import LinkedInLink from '../LinkedInLink';
import style from './Menu.module.css';
import MenuItem from './MenuItem';
import MobileMenu from './MobileMenu';
/**
 * ## Displays the menu with 2 viewports : **mobile** and **desktop**.
 * - Each link should have a **green coloration** when the user is **on the corresponding page**.
 * - On **desktop**, hovering the menu item will display a tooltip with the page's title.
 * - On **mobile**, clicking anywhere on the menu will hide the menu.
 *
 * @returns {JSX.Element}
 */
function Menu() {
  useTheme();
  const { pathname } = useLocation();

  return (
    <header id="navbar-collapse-toggle" className={style.header}>
      <ul
        className={cx(style.iconMenu, 'd-none d-lg-block')}
        data-testid="menuDesktop"
      >
        {menuItems.map((item) => (
          <MenuItem
            key={item.shortName}
            icon={item.icon}
            name={item.shortName}
            isCurrent={pathname === item.path}
            url={item.path}
          />
        ))}

        <li className={style.iconBox}>
          <LinkedInLink>
            <span>
              <FormattedMessage id="menu.linkedin" tagName="h2" />
            </span>
          </LinkedInLink>
        </li>
      </ul>

      <MobileMenu />
    </header>
  );
}

export default Menu;
